{
  "name": "ciberseguridad-frontend-auth",
  "version": "1.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:local": "ng serve --configuration local",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "build": "ng build --base-href /auth/ && npm run post:build",
    "build:development": "ng build --base-href /auth/ --configuration development && npm run post:build:development",
    "build:qa": "ng build --base-href /auth/ --configuration qa && npm run post:build:qa",
    "build:prod": "ng build --base-href /auth/ --configuration prod && npm run post:build:prod",
    "post:build:prod": "ts-node  --project ./bin/js/tsconfig.json ./bin/js/post-build.ts dist/ciberseguridad-frontend-auth auth.war build/prod",
    "post:build:development": "ts-node  --project ./bin/js/tsconfig.json ./bin/js/post-build.ts dist/ciberseguridad-frontend-auth auth.war build/development",
    "post:build:qa": "ts-node  --project ./bin/js/tsconfig.json ./bin/js/post-build.ts dist/ciberseguridad-frontend-auth auth.war build/qa",
    "post:build": "ts-node  --project ./bin/js/tsconfig.json ./bin/js/post-build.ts dist/ciberseguridad-frontend-auth auth.war build/prod"
  },
  "prettier": {
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.1.3",
    "@angular/cdk": "^20.1.3",
    "@angular/common": "^20.1.0",
    "@angular/compiler": "^20.1.0",
    "@angular/core": "^20.1.0",
    "@angular/forms": "^20.1.0",
    "@angular/material": "^20.1.3",
    "@angular/platform-browser": "^20.1.0",
    "@angular/router": "^20.1.0",
    "@tailwindcss/postcss": "^4.1.11",
    "crypto-js": "^4.1.1",
    "ngx-toastr": "^19.0.0",
    "ngx-ui-loader": "^19.0.0",
    "object-to-formdata": "^4.5.1",
    "postcss": "^8.5.6",
    "rxjs": "~7.8.0",
    "tailwindcss": "^4.1.11",
    "ts-node": "^10.9.2",
    "tslib": "^2.3.0",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^20.1.3",
    "@angular/cli": "^20.1.3",
    "@angular/compiler-cli": "^20.1.0",
    "@types/crypto-js": "^4.2.2",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^24.2.1",
    "jasmine-core": "~5.8.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.8.2"
  }
}
